import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {getContainer} from "../ioc/IOCSetup";
import {UserMessage} from "../http/protocol";
import {MessagePaginationParams} from "./MessageService";

export enum MessageActionType {
    MESSAGES_REQUEST = "@messages/request",
    ERROR ="@messages/error",
    MESSAGES_RESPONSE = "@messages/response",
    MESSAGES_APPEND = "@messages/append",
    MARK_READ = "@messages/markRead",
    MARK_ALL_AS_READ = "@messages/markAllAsRead",
    CLEAR_TOASTS = "@messages/clear-toasts"
}

export type MessageActions =
    { type : MessageActionType.MESSAGES_REQUEST } |
    { type : MessageActionType.ERROR, error : string} |
    { type : MessageActionType.MESSAGES_RESPONSE, messages : UserMessage[], unread:number} |
    { type : MessageActionType.MESSAGES_APPEND, messages : UserMessage[], unread:number} |
    { type : MessageActionType.MARK_READ, message : UserMessage} |
    { type : MessageActionType.MARK_ALL_AS_READ} |
    { type : MessageActionType.CLEAR_TOASTS };

export const clearToasts = () => (
    { type : MessageActionType.CLEAR_TOASTS }
)

export const fetchMessages = (params?: MessagePaginationParams) => {
    return async (dispatch : Dispatch, getState : () => AppState) => {
        dispatch({ type : MessageActionType.MESSAGES_REQUEST });
        try {
            let messages = await getContainer().getMessageService().getMessages(params);
            dispatch({type : MessageActionType.MESSAGES_RESPONSE, messages : messages.messages, unread:messages.unreadMessages});
        } catch (e) {
            dispatch({ type : MessageActionType.ERROR, error : e });
        }
    }
}

export const loadMoreMessages = (offset: number) => {
    return async (dispatch : Dispatch, getState : () => AppState) => {
        try {
            let messages = await getContainer().getMessageService().getMessages({ 
                limit: 20, 
                offset: offset, 
                ascending: false 
            });
            dispatch({
                type : MessageActionType.MESSAGES_APPEND, 
                messages : messages.messages, 
                unread: messages.unreadMessages
            });
        } catch (e) {
            dispatch({ type : MessageActionType.ERROR, error : e });
        }
    }
}

export const markRead = (id : number) => {
    return async (dispatch : Dispatch, getState : () => AppState) => {
        try {
            let message = await getContainer().getMessageService().getMessageAndMarkAsRead(id);
            dispatch({type : MessageActionType.MARK_READ, message : message});
        } catch (e) {
            dispatch({ type : MessageActionType.ERROR, error : e });
        }
    }
}
export const markAllAsRead = () => {
    getContainer().getMessageService().markAllAsRead();
    return {type : MessageActionType.MARK_ALL_AS_READ};
}